<template>
  <p
    class="pre"
    :class="[isEmoji(linkifiedComment) ? 'singe-emoji' : '']"
    v-html="linkifiedComment"
  />
</template>

<script>
  import linkifyHtml from 'linkifyjs/html'

  import emojiRegex from 'emoji-regex/text'

  export default {
    props: ['comments'],
    computed: {
      linkifiedComment() {
        // linkifyString already sanitizes input preventing xss
        return this.$sanitizeHtml(
          this.comments
            .map(comment =>
              linkifyHtml(
                comment
                  .replace(/&lt;em&gt;/g, '<i>')
                  .replace(/&lt;\/em&gt;/g, '</i>')
              )
            )
            .join('')
        )
      }
    },
    methods: {
      isEmoji(text) {
        let str = text.replace(/\s/g, '')

        const noEmojis = str.replace(emojiRegex(), '')

        const noSpace = noEmojis.replace(/[\s\n]/gm, '')

        return !noSpace && !/\d/g.test(str) && str.length <= 4
      }
    }
  }
</script>

<style scoped lang="scss">
  p {
    &.reply {
      padding-left: 10px;
    }
    &.singe-emoji {
      font-size: 30px;
    }
  }
</style>
